module.exports = {"status":"success","result":{"apiKey":"AIzaSyB3wk5GKFrrd0Jkt7dF0Ehjjrgy5tTegTU","databaseURL":"https://caazam-26c36.firebaseio.com","storageBucket":"caazam-26c36.appspot.com","authDomain":"caazam-26c36.firebaseapp.com","messagingSenderId":"872999175215","projectId":"caazam-26c36"}}


//////////////////
// WEBPACK FOOTER
// ./src/firebase-config.json
// module id = 546
// module chunks = 0